import { z } from 'zod'
import { Scorecard } from 'util/scorecard'

const ScorecardSummaryItemSchema = z.object({
  metric_name: z.string(),
  scorecard_band: z.string(),
  score: z.number(),
  updated_at: z.string(),
})

export const ScorecardSummaryResponseSchema = z.array(ScorecardSummaryItemSchema)

export type ScorecardSummaryData = Scorecard[]

export function deserializeScorecardSummaryData(data: unknown): ScorecardSummaryData {
  if (Array.isArray(data)) {
    return data.map((scorecardSummaryItem) => ({
      metricName: scorecardSummaryItem.metric_name,
      scorecardBand: scorecardSummaryItem.scorecard_band,
      score: scorecardSummaryItem.score,
      updatedAt: new Date(scorecardSummaryItem.updated_at),
    }))
  }

  return []
}
